export default {
  title: 'Actualités',
  newsLink: 'Voir toutes les actualités',
};
